<template>
  <div>
    <bio :text="text" />
    <div class="sm:px-4 md:px-8 leading-snug flex items-center">
      <div class="flex-auto w-2/3">Spencer Madsen (b. 1992)</div>
      <div class="flex-initial">
        <button @click.prevent="addClick">➕</button>
      </div>
    </div>
    <div class="sm:px-4 md:px-8">
      <draggable :list="text" handle=".handle">
        <div
          v-for="(line, i) in text"
          :key="`line-admin-${i}`"
          class="relative leading-snug pl-6 ml-6 md:ml-12"
        >
          <span class="handle absolute left-0 leading-none">👉</span>
          <bio-line-admin :line.sync="line" @remove="remove(i)" />
        </div>
      </draggable>
    </div>
    <div class="text-green mt-8 sm:px-4 md:px-8">
      <button @click.prevent="save">Save ✔️</button>
    </div>
    <notifications group="bio" />
  </div>
</template>

<script>
import draggable from 'vuedraggable'
import Bio from '@/components/Bio.vue'
import BioLineAdmin from '@/components/admin/BioLine.vue'
import stripTypenames from '@/util/strip-typenames'
import query from '@/graphql/queries/bio.gql'
import mutation from '@/graphql/mutations/save-bio.gql'

export default {
  name: 'BioAdmin',

  components: {
    draggable,
    Bio,
    BioLineAdmin
  },

  apollo: {
    $client: 'admin',

    text: {
      query,
      update({ bio }) {
        if (!bio) {
          bio = {}
        }
        bio = stripTypenames(bio)
        if (!bio.text || !(bio.text instanceof Array)) {
          bio.text = []
        }
        return bio.text
      }
    }
  },

  data: () => ({
    text: []
  }),

  methods: {
    addClick() {
      this.add()
    },

    add() {
      this.text.push({
        text: '',
        image: null,
        subtext: []
      })
    },

    remove(index) {
      this.text.splice(index, 1)
    },

    async save() {
      const text = this.text
      const variables = { bio: { text } }
      await this.$apollo
        .mutate({ mutation, variables })
        .then(({ data }) => {
          const text = data.saveBio
          this.$notify({
            group: 'bio',
            title: 'Saved',
            classes: 'success',
            text
          })
          this.$apollo.queries.text.refetch()
        })
        .catch(e => {
          // eslint-disable-next-line no-console
          console.error(e)
        })
    }
  }
}
</script>
